const nodatafound ={
    no_data_img:"./Images/Nodatafound/Nodatafound.jpg",
    unauth:"./Images/Nodatafound/404.png"
};

export default nodatafound;
